import { isCashierProcessingPath } from "../helpers/cashierProcessing.js";
import { getCookie } from "../helpers/cookie-service.js";
const appendMetaInformation = ({
  headJavaScript
}) => {
  const temp = document.createElement("div");
  temp.innerHTML = headJavaScript;
  const headMeta = temp.querySelectorAll("meta");
  headMeta.forEach((meta) => {
    document.head.appendChild(meta);
  });
  temp.remove();
};
var AppSetup = /* @__PURE__ */ ((AppSetup2) => {
  AppSetup2["bootstrap"] = "/api/config/bootstrap?pageUrl=";
  AppSetup2["availability"] = "/api/v2/page/availability?pageUrl=";
  AppSetup2["translates"] = "/api/v2/translation/get?pageUrl=";
  return AppSetup2;
})(AppSetup || {});
const getQueryParam = () => new URLSearchParams(window.location.search);
const generateUrl = (type, pathname, apiCmsHost) => {
  const imbaWebView = getQueryParam().get("imbaWebView") || null;
  let basePart = `${apiCmsHost || ""}${type}${pathname}`;
  if (getCookie("preferred-language-client")) {
    basePart = `${basePart}&preferredLanguage=${getCookie("preferred-language-client")}`;
  }
  if (imbaWebView) {
    basePart = `${basePart}&nb=1`;
  }
  return basePart;
};
const getBaseApplicationData = async (pathname, search, apiCmsHost, platformApiHost, availabilityV3) => {
  const fullPathName = `${pathname}${search}`;
  return Promise.all([
    fetch(
      `${generateUrl("/api/config/bootstrap?pageUrl=", encodeURIComponent(fullPathName), apiCmsHost)}${window.isPrerender ? "&prerenderBuild=true" : ""}`
    ),
    fetch(
      `${generateUrl(availabilityV3 ? availabilityV3 : "/api/v2/page/availability?pageUrl=", encodeURIComponent(fullPathName), apiCmsHost)}${window.isPrerender ? "&prerenderBuild=true" : ""}`
    ),
    fetch(
      `${generateUrl("/api/v2/translation/get?pageUrl=", encodeURIComponent(fullPathName), apiCmsHost)}&classificationsStrategy=2&classifications=db column`
    ),
    fetch(`${platformApiHost}/api/v2/rev2/configurations`),
    fetch("https://dqvp7q24q4toc.cloudfront.net/remotes/remotes.json")
  ]);
};
var AvailabilityStatus = /* @__PURE__ */ ((AvailabilityStatus2) => {
  AvailabilityStatus2["ok"] = "ok";
  AvailabilityStatus2["redirect"] = "redirect";
  AvailabilityStatus2["blocked"] = "blocked";
  AvailabilityStatus2["maintenance"] = "maintenance";
  AvailabilityStatus2["notFound"] = "not_found";
  AvailabilityStatus2["externalRedirect"] = "external_redirect";
  return AvailabilityStatus2;
})(AvailabilityStatus || {});
const safeParseJson = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
};
const handleDisableRedirect = (status) => {
  if ((window.googlePageSpeed || window.disableRedirect) && [
    "redirect",
    "external_redirect"
    /* externalRedirect */
  ].includes(status)) {
    return "ok";
  }
  return status;
};
const getData = async ({ preloadData, pathname, search, apiCmsHost, platformApi, availabilityV3 }) => {
  if (!preloadData) {
    const bootstrap = await getBaseApplicationData(pathname, search, apiCmsHost, platformApi, availabilityV3);
    const baseApplicationSetup = await safeParseJson(bootstrap[0]);
    const pageAvailability = await safeParseJson(bootstrap[1]);
    const translations = await safeParseJson(bootstrap[2]);
    const platformSetup = await safeParseJson(bootstrap[3]);
    const remotesManifest = await safeParseJson(bootstrap[4]);
    return {
      baseApplicationSetup,
      pageAvailability,
      translations,
      platformSetup,
      remotesManifest
    };
  }
  if (preloadData) {
    const { bootstrap: baseApplicationSetup, availability: pageAvailability, translates: translations, configurations, remotesManifest } = preloadData;
    const { data: platformSetup } = configurations || {};
    return {
      baseApplicationSetup,
      pageAvailability,
      translations,
      platformSetup,
      remotesManifest
    };
  }
};
const fetchBaseWindowConfig = async (pathname, search, environment, preloadData) => {
  const { apiCmsHost, platformApiHost, availabilityV3 } = environment;
  const platformApi = !platformApiHost ? `https://platform.${window.location.host}` : platformApiHost;
  const {
    baseApplicationSetup,
    pageAvailability,
    translations,
    platformSetup,
    remotesManifest
  } = await getData({
    preloadData,
    pathname,
    search,
    apiCmsHost,
    platformApi,
    availabilityV3
  });
  const { data: pageAvailabilityData = {} } = pageAvailability || {};
  const { status: s, payload } = pageAvailabilityData;
  const status = handleDisableRedirect(s);
  const { data = {} } = baseApplicationSetup || {};
  const {
    frontSettings,
    uriPaths,
    languages,
    platformUrl,
    primaryLanguage,
    preferredLanguage,
    javaScripts,
    sidemenu
  } = data || {};
  return Promise.resolve().then(async (result) => {
    const [, languagePart] = pathname.split("/");
    const { bodyJavaScript, headJavaScript, liveChat: liveChatScript } = javaScripts || {};
    if (!window.isPrerender) {
      if (status === "ok") {
        appendMetaInformation({
          headJavaScript
        });
      }
    }
    if (status === "redirect" || status === "external_redirect") {
      if (window.googlePageSpeed && window.location.search.includes("ipDebug")) {
        window.googlePageSpeedRedirectDebug = true;
        window.availabilityResponse = pageAvailability;
      }
      if (!window.googlePageSpeed) {
        window.location = payload;
      }
    }
    if (status === "not_found" && !isCashierProcessingPath) {
      if (window.isPrerender) {
        window.location = `/${preferredLanguage.url}/404`;
      }
      if (!window.isPrerender) {
        window.history.replaceState({}, pathname, `${preferredLanguage.url}/404`);
      }
    }
    if (languages && !languages[languagePart]) {
      if ((preferredLanguage == null ? void 0 : preferredLanguage.url) !== (primaryLanguage == null ? void 0 : primaryLanguage.url)) {
        if (window.isPrerender) {
          window.location = `/${preferredLanguage.url}${pathname}${search}`;
        }
        if (!window.isPrerender) {
          window.history.replaceState({}, pathname, `${preferredLanguage.url}${pathname}${search}`);
        }
      }
    }
    const htmlElement = document.querySelector("html");
    if (htmlElement && languages) {
      htmlElement.setAttribute("lang", languages[(preferredLanguage == null ? void 0 : preferredLanguage.url) || primaryLanguage.url].iso);
    }
    if (apiCmsHost && frontSettings) {
      frontSettings["siteApi"] = apiCmsHost;
    }
    try {
      const currentLanguageIso = languages == null ? void 0 : languages[(preferredLanguage == null ? void 0 : preferredLanguage.url) || primaryLanguage.url].iso;
      const apiEndpointSetting = platformUrl == null ? void 0 : platformUrl.split("/api")[0];
      window.apiEndpoint = apiEndpointSetting;
      window.PlatformSetup = frontSettings;
      window.languages = languages;
      window.language = languages == null ? void 0 : languages[(preferredLanguage == null ? void 0 : preferredLanguage.url) || primaryLanguage.url].url;
      window.locale = languages == null ? void 0 : languages[(preferredLanguage == null ? void 0 : preferredLanguage.url) || primaryLanguage.url].locale;
      window.langIso = currentLanguageIso;
      window.betradarIso = languages == null ? void 0 : languages[(preferredLanguage == null ? void 0 : preferredLanguage.url) || primaryLanguage.url].betradarIso;
      window.primaryLanguage = primaryLanguage == null ? void 0 : primaryLanguage.url;
      window.paths = uriPaths;
      window.isFrontRender = true;
      window.translates = translations == null ? void 0 : translations.data;
      window.applicationSetup = platformSetup == null ? void 0 : platformSetup.data;
      window.currencyVariables = null;
      window.spa = true;
      window.additionalSideBarMenu = sidemenu;
      window.__REMOTES_MANIFEST__ = remotesManifest || {};
      window.debugProto = new URLSearchParams(window.location.search).get("debugProto") === "true";
      if (!window.isPrerender && !window.googlePageSpeed) {
        window.bodyScripts = JSON.stringify(bodyJavaScript);
        window.headJavaScript = JSON.stringify(headJavaScript);
        window.liveChatScript = JSON.stringify(liveChatScript);
      }
      return {
        status,
        payload,
        loaded: true,
        data
      };
    } catch (e) {
      console.error("script add failed", e);
      return {
        status,
        payload,
        loaded: true,
        data
      };
    }
  });
};
export {
  AppSetup,
  AvailabilityStatus,
  appendMetaInformation,
  fetchBaseWindowConfig,
  getBaseApplicationData,
  safeParseJson
};
